import _inject from "@stylexjs/stylex/lib/stylex-inject";
import React from 'react';
import { useDocumentTitle } from "usehooks-ts";
import { msg } from "src/app/msg";
import { msgs } from "nood-comp/src/locale/msgs";
import { NavLink } from "react-router-dom";
import { queryStringMod } from "nood-comp/src/util/converters/converters";
import * as stylex from "@stylexjs/stylex";
import Table from "nood-comp/src/comp/data/table/Table";
export default function Audits(props) {
  useDocumentTitle(msg.title(msgs.many(msg.orguser)));
  return /*#__PURE__*/React.createElement(Table, {
    data_source: "/orgusers",
    cols: [{
      label: "Username",
      width: 120,
      property: "username",
      content: function content(orguser) {
        return /*#__PURE__*/React.createElement(NavLink, {
          to: queryStringMod({
            "do": "view",
            id: orguser.id
          })
        }, orguser.username);
      },
      filterTextfieldWidth: 120,
      filterType: "text",
      icon: "tag"
    }, {
      property: "display_name",
      label: "Display Name",
      filterType: "text",
      icon: "user"
    }, {
      property: "email",
      label: "Email",
      filterType: "text",
      icon: "inbox"
    }, {
      content: function content(orguser, idx) {
        var _orguser$org, _orguser$org2;
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(NavLink, {
          to: "/orgs?pg=orgs&do=view&id=".concat(orguser.org.id)
        }, (_orguser$org = orguser.org) === null || _orguser$org === void 0 ? void 0 : _orguser$org.display_name), " ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
          className: "text-secondary"
        }, (_orguser$org2 = orguser.org) === null || _orguser$org2 === void 0 ? void 0 : _orguser$org2.username));
      },
      label: "Organization"
    }]
  });
}

// @ts-ignore
_inject("@media(min-width:501px){.evbw5gen.evbw5gen{left:270px}}", 4200);
_inject("@media(max-width:500px){.ev103ggzd.ev103ggzd{left:0}}", 4200);
_inject("@media(max-width:500px){.ev1qqrqh5.ev1qqrqh5{bottom:50px}}", 4200);